// Navigation: scroll spy for the sticky header, scroll-to-top button and CV export.

import { generateCV } from '../utils/cvExport';

const ACTIVE_CLASSES = ['bg-n100', 'text-graphite', 'font-semibold'];
const INACTIVE_CLASSES = ['text-n500', 'font-medium'];

export function initNavigation() {
    const navLinks = document.querySelectorAll('.nav-link');

    // --- CV export ---
    document.getElementById('export-cv-btn')?.addEventListener('click', generateCV);

    // --- Scroll Spy & Scroll To Top ---
    const scrollBtn = document.getElementById('scrollTop');
    const sectionIds = ['home', 'om', 'erfaring', 'utdanning', 'sertifiseringer', 'ferdigheter', 'prosjekter', 'kontakt'];

    // Cache DOM lookups for performance
    const sections = sectionIds.map(id => ({ id, el: document.getElementById(id) }));
    const linksData = Array.from(navLinks).map(link => ({
        link,
        href: link.getAttribute('href')
    }));

    let lastActiveId = '';
    let isScrollBtnVisible = false;
    let isTicking = false;

    window.addEventListener('scroll', () => {
        if (!isTicking) {
            isTicking = true;
            window.requestAnimationFrame(() => {
                // Scroll Top Button visibility
                if (scrollBtn) {
                    const shouldBeVisible = window.scrollY > 500;
                    if (shouldBeVisible !== isScrollBtnVisible) {
                        isScrollBtnVisible = shouldBeVisible;
                        if (shouldBeVisible) {
                            scrollBtn.classList.remove('opacity-0', 'translate-y-4', 'pointer-events-none');
                            scrollBtn.classList.add('opacity-100', 'translate-y-0', 'pointer-events-auto');
                            scrollBtn.removeAttribute('tabindex');
                            scrollBtn.removeAttribute('aria-hidden');
                        } else {
                            scrollBtn.classList.add('opacity-0', 'translate-y-4', 'pointer-events-none');
                            scrollBtn.classList.remove('opacity-100', 'translate-y-0', 'pointer-events-auto');
                            scrollBtn.setAttribute('tabindex', '-1');
                            scrollBtn.setAttribute('aria-hidden', 'true');
                        }
                    }
                }

                // Active Link Highlighting (surface + weight, never colour alone)
                let currentId = '';
                const scrollPos = window.scrollY + window.innerHeight * 0.3; // Trigger point 30% down screen

                for (const { id, el } of sections) {
                    if (el && el.offsetTop <= scrollPos) {
                        currentId = id;
                    }
                }

                if (currentId !== lastActiveId) {
                    lastActiveId = currentId;

                    linksData.forEach(({ link, href }) => {
                        if (href === '#' + currentId) {
                            link.classList.add(...ACTIVE_CLASSES);
                            link.classList.remove(...INACTIVE_CLASSES);
                        } else {
                            link.classList.remove(...ACTIVE_CLASSES);
                            link.classList.add(...INACTIVE_CLASSES);
                        }
                    });
                }

                isTicking = false;
            });
        }
    });
}
